import { Phone, MapPin, Video } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { PayingForServices } from "../components/site/PayingForServices";
import { ContactForm } from "../components/contact/ContactForm";
import { Reveal } from "../components/site/Motion";
import { COVERAGE_NOTE, PHONE_DISPLAY, PHONE_HREF } from "../data/content";

const INFO = [
  { icon: Phone, label: "Call", value: PHONE_DISPLAY, href: PHONE_HREF, id: "contact-phone-link" },
  { icon: MapPin, label: "Based in", value: "Columbus, Ohio", id: "contact-location" },
  { icon: Video, label: "Sessions", value: "In-person or by telehealth", id: "contact-sessions" },
];

export default function Contact() {
  return (
    <main id="main-content" data-testid="contact-page">
      <PageHero eyebrow="Contact" lines={["Let's talk about", <>what <span className="italic text-[#A9533A]">comes next.</span></>]} intro={COVERAGE_NOTE} testid="contact-hero" />
      <section className="bg-[#FDFBF7] pb-20 sm:pb-28">
        <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 lg:grid-cols-12 lg:gap-16 lg:px-12">
          <Reveal className="lg:col-span-4">
            <div className="space-y-4">
              {INFO.map(({ icon: Icon, label, value, href, id }) => {
                const inner = (
                  <>
                    <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#E5EBE3] text-[#2C3E33]"><Icon className="h-5 w-5" /></span>
                    <span><span className="font-mono-ui block text-xs uppercase tracking-[0.18em] text-[#4A554D]">{label}</span><span className="font-serif-display text-2xl text-[#1E2621]">{value}</span></span>
                  </>
                );
                return href ? (
                  <a key={id} href={href} className="flex items-center gap-4 rounded-2xl border border-[#E2DCD0] p-5 transition-colors hover:border-[#C86D51]" data-testid={id}>{inner}</a>
                ) : (
                  <div key={id} className="flex items-center gap-4 rounded-2xl border border-[#E2DCD0] p-5" data-testid={id}>{inner}</div>
                );
              })}
            </div>
            <div className="relative mt-6 hidden aspect-[4/3] overflow-hidden rounded-[2rem] rounded-br-[6rem] sm:block">
              <img src="/images/team-hands.webp" alt="A team joining hands together in sunlight" className="h-full w-full object-cover" />
            </div>
          </Reveal>
          <Reveal className="lg:col-span-8" delay={0.1}><ContactForm /></Reveal>
        </div>
      </section>
      <div className="border-t border-[#E2DCD0]"><PayingForServices /></div>
    </main>
  );
}
